export const Roles = {
    TRAVELER : 'Traveler',
    AGENCY_USER : 'Primary Contact',
    PHOTO_ADMIN: 'Photo Admin',
    SUPER_ADMIN: 'super admin',
}


// WEBPACK FOOTER //
// ./src/constants/Roles.jsx